import { defaultFixAsset } from "./state";

export function setFixAssets(state, data) {
  // Agregamos los datos de la tabla
  state.tableFixAssets.items = data.data;

  // Quitamos los valores de la tabla del arreglo
  delete data.data;

  // Agregamos los datos de la paginacion
  state.tableFixAssets.pagination = data;
}

export function setFixAssetAdditions(state, data) {
  // Agregamos los datos de la tabla
  state.tableFixAssetAdditions.items = data.data;

  // // Quitamos los valores de la tabla del arreglo
  // delete data.data;

  // // Agregamos los datos de la paginacion
  // state.tableFixAssetAdditions.pagination = data;
}

export function setFixAssetMonthlyDepreciation(state, data) {
  state.tableFixAssetMonthlyDepreciation.items = data;
}

export function setTableFixAssetDocumentDepreciationLoading(state, value) {
  state.tableFixAssetDocumentDepreciationLoading = value;
}

export function setFixAssetDocumentDepreciation(state, data) {
  state.tableFixAssetDocumentDepreciation.items = data;
}

export function setActiveGroups(state, data) {
  state.activeGroups = data;
}

export function setClasses(state, data) {
  state.classes = data;
}

export function setCostCenters(state, data) {
  state.costCenters = data;
}

export function setCities(state, data) {
  state.cities = data;
}

export function setSubscriber(state, data) {
  state.subscriber = data;
}

export function setPolicyProviders(state, data) {
  state.policyProviders = data;
}

export function setMaintenanceProviders(state, data) {
  state.maintenanceProviders = data;
}

export function setValuationsProviders(state, data) {
  state.valuationsProviders = data;
}

export function setProviders(state, data) {
  state.providers = data;
}

export function setContactResponsibles(state, data) {
  state.contactResponsibles = data;
}

export function setContactsSale(state, data) {
  state.contactsSale = data;
}

export function setDerecognizedTypes(state, data) {
  state.derecognizedTypes = data;
}

export function setErrorForm(state, value) {
  state.errorForm = value;
}

export function setAction(state, value) {
  state.action = value;
}

export function setFixAsset(state, data) {
  state.fixAsset = data;
}

export function setFixAssetAddition(state, data) {
  state.fixAssetAddition = data;
}

export function setAttributeFixAsset(state, data) {
  state.fixAsset = {
    ...state.fixAsset,
    ...data
  };
}

export function resetFixAsset(state, data) {
  state.fixAsset = defaultFixAsset();
}

export function resetFixAssetAddition(state, data) {
  state.fixAssetAddition = {};
}

export function setInspectionStatus(state, data) {
  state.inspectionStatus = data;
}

export function setDepreciationVoucherFixAssetsDocuments(state, data) {
  state.depreciationVoucherFixAssetsDocuments = data;
}

export function setFixAssetsPPal(state, data) {
  state.fixAssetsPPal = data;
}

export function setHistoryDepreciation(state, data) {
  state.historyDepreciation = data;
}

export function setVoucherTypes(state, data) {
  state.voucherTypes = data;
}

export function setContacts(state, data) {
  state.contacts = data;
}


// WEBPACK FOOTER //
// ./src/modules/fixAssets/mutations.js